module.exports = __webpack_public_path__ + "img/icon58.9fd135b8.png";